import React from 'react';
import { IconProps } from '.';

const SvgBarChartFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M5.5 12a2 2 0 0 1 1.999 1.999L7.5 19a2 2 0 0 1-3.999.001L3.5 14a2 2 0 0 1 2-2ZM12 4a2 2 0 0 1 2 2v13a2 2 0 1 1-4 0V6a2 2 0 0 1 2-2ZM18.5 8a2 2 0 0 1 2 2v9a2 2 0 1 1-4 0v-9a2 2 0 0 1 2-2Z'
      />
    </svg>
  );
};

export default SvgBarChartFillRounded;
